import { AppStoreBannerElement } from './AppStoreBanner.element'

if (!window.customElements.get('app-store-banner')) {
  window.customElements.define('app-store-banner', AppStoreBannerElement)
}
